import React from 'react'
import styled from 'styled-components'

import Theme from '../../../styles/theme'
import { breakpoints, media } from '../../../styles/media'

import Container from '../../../components/layout/Container'
import LazyImage from '../../../components/display/LazyImage'
import UniformOverlay from '../../../components/display/Overlay/Uniform'

import { CallToActionButton } from '../shared'

import {
  desktopImage as defaultDesktopImage,
  mobileImage as defaultMobileImage,
} from './content'

const OVERLAY_Z_INDEX = 1

const Wrapper = styled.section`
  position: relative;

  height: calc((110 / 267) * 100vw);
  min-height: 400px;
  max-height: 800px;
  max-width: 1300px;

  ${media.md`
    min-height: 500px;
  `}

  border-radius: 8px;
  overflow: hidden;

  color: white;
  background-color: ${({ theme }) => theme['-ds-core-400'].value};

  ${Container} {
    position: relative;

    display: flex;
    align-items: center;
    justify-content: center;

    width: unset;
    height: 100%;

    text-align: center;
    z-index: ${OVERLAY_Z_INDEX + 1};
  }
`

const Img = styled(LazyImage)`
  object-position: bottom center;
`

const Text = styled.div`
  position: relative;
  top: -20%;

  ${media.md`
    top: -25%;
  `}
`

const Subtitle = styled.h3`
  text-transform: uppercase;
  font-size: ${({ theme }) => theme['-ds-font-size-xxs']['font-size'].value};
  font-weight: 300;
  margin: 0;

  ${media.md`
    font-size: ${({ theme }) => theme['-ds-font-size-sm']['font-size'].value};
  `}
`

const Title = styled.h4`
  font-size: ${({ theme }) => theme['-ds-font-size-lg']['font-size'].value};
  line-height: 1.2;
  margin: 16px 0;

  ${media.lg`
    font-size: ${({ theme }) => theme['-ds-font-size-xxl']['font-size'].value};
    font-weight: 400;
    max-width: 420px;
  `}
`

type VoucherInfoProps = {
  mobileImage?: string
  desktopImage?: string
}

const VoucherInfo = ({
  mobileImage = defaultMobileImage,
  desktopImage = defaultDesktopImage,
}: VoucherInfoProps) => (
  <Wrapper>
    <UniformOverlay
      color={Theme['-ds-core-300'].value}
      zIndex={OVERLAY_Z_INDEX}
      opacity={0.1}
    />
    <Container>
      <Text>
        <Subtitle>Riparide Vouchers</Subtitle>
        <Title>Memories are perhaps the greatest gifts of all</Title>
        <CallToActionButton as="a" href="/vouchers" rounded white>
          Buy a Gift Voucher
        </CallToActionButton>
      </Text>
    </Container>
    <picture>
      <source
        data-srcset={desktopImage}
        media={`(min-width: ${breakpoints.lg}px)`}
      />
      <source
        data-srcset={mobileImage}
        media={`(max-width: ${breakpoints.lg}px)`}
      />
      <Img data-src={desktopImage} cover alt="Riparide vouchers" />
    </picture>
  </Wrapper>
)

export default VoucherInfo
